<template>
  <div id="app" @mousemove="onMouseMove" @click="$hub.emit('click')" class="u-full-vp-width u-full-vp-height u-relative u-overflow-hidden">
    <div ref="baseContainerWebGL" class="u-wrapper-panel"/>
    <div ref="containerCSS3D" class="u-wrapper-panel u-pointer-none u-overflow-hidden"/>
    <div ref="objectContainerWebGL" class="u-wrapper-panel u-pointer-none"/>
    <scene v-if="loaded" />
  </div>
</template>

<script>
import App from './App'

import { webGL } from '@/webGL/WebGL'

import Scene from '@/components/Scene'

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import {
  AmbientLight,
  SphereGeometry,
  MeshNormalMaterial,
  Mesh
} from 'three'

export default {
  name: 'App',

  mixins: [App],

  components: {
    Scene
  },

  computed: {
    loaded () {
      return this.$store.getters['data/loaded']
    }
  },

  created () {
    this.pointerevent = null

    if (this.$route.params.slug) {
      this.$store.dispatch('data/entry', this.$route.params.slug)
    }
  },

  mounted () {
    const ambient = new AmbientLight(0xffffff)
    webGL.objectScene.add(ambient)

    const geo = new SphereGeometry(100)
    const mat = new MeshNormalMaterial()
    mat.flatShading = true
    this.mesh = new Mesh(geo, mat)
    this.mesh.position.z = -100

    this.onResize()

    // new OrbitControls(webGL.camera, this.$root.$el)
  },

  methods: {
    onUpdate (time) {
      if (this.pointerevent) {
        this.$device.setRaycast(this.pointerevent, webGL.camera)
      }

      this._onUpdate(time)
    },
    onMouseMove (event) {
      this.pointerevent = event
    }
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<!-- <style lang="stylus">
@import '~@/styles/settings/variables'
</style> -->
